import { Trans } from "next-i18next";
import { useTrans } from "@/utils/useTrans";

// 프로토/Figma Hero: 가운데 정렬, H1(40px/400, 마침표 없음) + 서브타이틀 + 통계(숫자 볼드).
export default function HeroSection({ totalCount }: { totalCount: number }) {
  const { t } = useTrans(["where-to-try"]);
  return (
    <div className="flex w-full flex-col items-center gap-3.5 text-center">
      <h1 className="text-3xl font-400 leading-tight tracking-tight text-coolgray-100 laptop:text-[40px] laptop:leading-[48px]">
        {t("Feel bHaptics in person")}
      </h1>
      <p className="max-w-[600px] text-base text-coolgray-60">
        {t(
          "Haptics is something you have to experience to understand. Find a partner venue near you and try the full-body suit before you buy.",
        )}
      </p>
      <div className="mt-1 text-sm text-coolgray-50">
        {/* 숫자만 볼드(Figma). i18n 어순 안전 위해 <Trans>로 <b> 매핑(번역값이 {{count}} 위치 결정). */}
        <Trans
          t={t}
          i18nKey="{{count}} venues worldwide"
          defaultValue={`<b>${totalCount}</b> venues worldwide`}
          components={{ b: <span className="font-600 text-coolgray-90" /> }}
          values={{ count: totalCount }}
        />
      </div>
    </div>
  );
}
